import { useRef } from "react";
import ScrollableNavs from "../../../reusableUi/DropDownBar";
import BurgerMenu from "../../../reusableUi/BurgerMenu";
import servicesHeroImage from "../pictures/services-hero-plumber.webp";
import PrimaryButton from "../../../reusableUi/PrimaryButton";
import { Link, useNavigate } from "react-router-dom";
import { Wrench, Phone, ArrowLeft, Clock, Shield, Star, Mail } from "lucide-react";

export default function ServicesHero() {
  const upSection = useRef(null);
  const navigate = useNavigate();

const TRUST_BADGES = [
  { icon: <Clock className="w-4 h-4" />, label: "24 / 7 Response" },
  { icon: <Shield className="w-4 h-4" />, label: "Licensed & Insured" },
  { icon: <Star className="w-4 h-4" />, label: "4.9★ Rated" },
];
  const goBack = () => (window.history.length > 1 ? navigate(-1) : navigate("/"));

  return (
    <header className="max-w-[90%] mx-auto xl:max-w-6xl">

      {/* ── Mobile nav ── */}
      <nav className="md:hidden flex items-center justify-between py-5 mb-4">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-md shadow-blue-600/30">
            <Wrench className="w-4 h-4 text-white" />
          </span>
          <span className="text-xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
        </Link>
        <BurgerMenu />
      </nav>

      {/* ── Tablet nav ── */}
      <nav className="hidden md:flex lg:hidden items-center justify-between py-5 mb-6">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-md shadow-blue-600/30">
            <Wrench className="w-4 h-4 text-white" />
          </span>
          <span className="text-xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
        </Link>
        <ul className="flex items-center gap-8">
          <li>
            <button onClick={goBack} className="flex items-center gap-1.5 font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">
              <ArrowLeft className="w-4 h-4" /> Go Back
            </button>
          </li>
          <li><a href="#faqs" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">FAQs</a></li>
          <li>
            <a href="#footer" className="text-sm font-bold bg-blue-600 hover:bg-blue-700 transition-colors px-5 py-2.5 text-white rounded-xl shadow-md shadow-blue-600/25">
              Contact Us
            </a>
          </li>
        </ul>
      </nav>

      {/* ── Desktop nav ── */}
      <nav className="hidden lg:flex items-center justify-between py-6 mb-12">
        <Link to="/" className="flex items-center gap-3">
          <span className="w-9 h-9 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-600/30">
            <Wrench className="w-4 h-4 text-white" />
          </span>
          <span className="text-2xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
        </Link>
        <ul className="flex items-center gap-10">
          <li>
            <button onClick={goBack} className="flex items-center gap-1.5 font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">
              <ArrowLeft className="w-4 h-4" /> Go Back
            </button>
          </li>
          <li><Link to="/locations" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">Service Areas</Link></li>
          <li><a href="#faqs" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">FAQs</a></li>
          <li>
            <a href="#footer" className="flex items-center gap-2 font-bold bg-blue-600 hover:bg-blue-700 transition-all px-5 py-2.5 text-white rounded-xl shadow-md shadow-blue-600/25 text-sm">
              <Mail className="w-4 h-4" /> Contact
            </a>
          </li>
        </ul>
      </nav>

      <ScrollableNavs upSectionRef={upSection} />

      {/* ── Hero ── */}
      <div ref={upSection} className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 pb-18 items-center">

        {/* Copy */}
        <div className="space-y-8">
          <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
            Same-Day Service Available
          </div>
          <div className="space-y-4">
            <h1 className="font-black text-gray-900 text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Services We <span className="text-blue-600">Offer</span>
            </h1>
            <p className="text-gray-500 text-lg leading-relaxed max-w-md">
              Expert plumbing for leaks, clogs, and repairs of all kinds. Transparent pricing, fast response, and done right the first time.
            </p>
          </div>
          <PrimaryButton />
        </div>

        {/* Image */}
     <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-0">
                {/* Decorative offset frame */}
                <div aria-hidden="true" className="absolute inset-0 rounded-3xl border-2 border-blue-100 translate-x-3 translate-y-3 -z-10" />
    
                <img
                  src={servicesHeroImage}
                  className="w-full rounded-3xl shadow-2xl object-cover max-h-[520px]"
                  alt="A plumber fixing a kitchen faucet."
                />
              </div>
      </div>
      {/* Trust badges */}
            <div className="flex flex-wrap items-center justify-center gap-2.5 pt-0 pb-6">
              {TRUST_BADGES.map(({ icon, label }) => (
                <div key={label} className="flex items-center gap-1.5 text-xs font-semibold text-gray-500 bg-gray-50 border border-gray-200 px-3 py-1.5 rounded-lg">
                  {icon}
                  {label}
                </div>
              ))}
            </div>
    </header>
  );
}